<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('you-going-send') }} {{ this.countClients }}
            {{ num2word(this.countClients, [$t('message').toLowerCase(), $t('message-1').toLowerCase(), $t('message-2').toLowerCase()]) }}
            по {{ this.amountMethod.price }} {{ num2word(this.amountMethod.price, [$t('rubl-1').toLowerCase(), $t('rubl-2').toLowerCase(), $t('rubl').toLowerCase()]) }}/{{ this.amountMethod.name }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="light-help">{{ $t('shipping-cost') }}
            {{ this.getAmountForMailing(this.amountMethod.price, this.countClients) }}
            {{ num2word(parseFloat(this.amountMethod.price) * parseFloat(this.countClients), ['рубля', 'рублю', 'рублей']) }} </p>
          <p class="light-attention">
            <span style="color: #FF0000;">!</span>
            {{ $t('attention-balance') }}</p>
          <div class="account__balance">
            <div class="account__balance-header">
              {{ $t('account-balance') }}
            </div>
            <div class="account__balance-sum">
             {{ this.finance.balance }} {{ $t('rub') }}
            </div>
            <div class="account__balance-deposit">
              <span class="help-donate" v-if="this.finance.balance <= 0">{{ $t('balance-offer-help') }}</span>
              <router-link class="btn btn-secondary" to="finance">{{ $t('deposit') }}</router-link>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="accept">{{ $t('send') }}</button>
          <span class="help-donate" style="position: absolute; bottom: 0;" v-if="this.finance.balance <= 0">{{ $t('attention-start-mailing') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.help-donate{
  display: block;
  text-align: center;
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 135%;
  color: #FF0000;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
  position: relative;
}
.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
}
.light-attention{
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  margin-top: 31px !important;
  margin-bottom: 5px !important;
}
.account__balance{
  background: rgba(233, 159, 84, 0.1);
  border: 1px dashed #E99F54;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 10px 0 10px 0;
  max-width: 430px;
  height: 203px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.account__balance .account__balance-header{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
.account__balance .account__balance-sum{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
</style>

<script>
import axios from "axios";

export default {
  name: 'accept-mailing-money',
  props: ['aSegments', 'selectedSegment', 'method'],
  data: function(){
    return{
      errors: [],
      segments: this.aSegments,
      price: 0,
      name: '',
      finance: [],
    }
  },
  created: function(){
    this.getUserInfo();
  },
  computed: {
    countClients: function(){
      return this.getCountClientInSegment(this.aSegments, this.selectedSegment);
    },
    amountMethod: function(){
      return this.getAmountAboutMethod();
    }
  },
  methods: {
    getAmountForMailing: function(amount, countClient){
      if(amount && countClient){
        return parseFloat(amount) * parseFloat(countClient);
      }else{
        return 0;
      }
    },
    num2word: function(num, words){
      num = num % 100;
      if (num > 19) {
        num = num % 10;
      }
      switch (num) {
        case 1: {
          return(words[0]);
        }
        case 2: case 3: case 4: {
          return(words[1]);
        }
        default: {
          return(words[0]);
        }
      }
    },
    getCountClientInSegment: function(segments, selected){
      let count = 0;
      if(segments.length > 0){
        segments.map(function(value) {
          if(value.id == selected){
            count = value.clientCount;
          }
        });
        return count;
      }
    },
    getUserInfo: function () {
      axios.post('getUser').then(response => {
        var status = response.data.status;
        if (status) {
          this.finance = response.data.user;
          this.getAmountAboutMethod();
        }
      });
    },
    getAmountAboutMethod: function(){
      let data = {}
      if(this.method == 1){
        return data = {
          price: this.finance.telegram,
          name: 'Telegram',
        }
      }else if(this.method == 2){
        return data = {
          price: this.finance.viber,
          name: 'Viber',
        }
      }else if(this.method == 3){
        return data = {
          price: this.finance.sms,
          name: 'SMS',
        }
      }else if(this.method == 4){
        return data = {
          price: this.finance.email,
          name: 'Email',
        }
      }
    },
    accept: function(){
      this.close();
      this.$root.$emit('createMailing');
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>